import {Pipe, PipeTransform} from '@angular/core';
import {SortByDatePipe} from './sort-by-date.pipe';
import {BoulderList} from '../model/boulder-list';

@Pipe({
  name: 'sortBoulderLists',
  pure: false
})
export class SortBoulderListsPipe implements PipeTransform {

  constructor() {
  }


  transform(boulderList: BoulderList[]): any {
    if (!boulderList || boulderList.length == 0) {
      return boulderList;
    }
    boulderList.sort((a: BoulderList, b: BoulderList) => {
      if (a.isProjectList) {
        return -1;
      } else if (b.isProjectList) {
        return 1;
      }
      return SortByDatePipe.compareDates(a.date, b.date);
    });
    return boulderList;
  }
}
